import {
  PreviousTimeTracked,
  TimeTrackingInfo,
} from "./../time-tracking/models/models";
import { Company } from "./../../../../shared-data.service";
import { StartWithOngoingEntryModalComponent } from "./../time-tracking/start-with-ongoing-entry-modal/start-with-ongoing-entry-modal.component";

import { TimeTrackingDetailsModalComponent } from "../time-tracking/time-tracking-details-modal/time-tracking-details-modal.component";
import { DeleteConfirmationModalComponent } from "./../../modals/delete-confirmation-modal.component";
import { JobTimeTrackingModalComponent } from "../time-tracking/job-time-tracking-modal/job-time-tracking-modal.component";
import { ConversationsService } from "src/app/dashboard/conversations/conversations.service";
import { DashboardService } from "./../../../../dashboard.service";
import { NewTrackedItemModalComponent } from "src/app/dashboard/conversations/modals/new-tracked-item-modal.component";
import { Subject, Subscription, takeUntil } from "rxjs";
import { environment } from "src/environments/environment";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { JobsStore } from "./../jobs.store";
import {
  BsModalRef,
  BsModalService,
  ModalDirective,
} from "ngx-bootstrap/modal";
import { JobsService } from "./../jobs.service";
import { Job, Task, TaskGroup } from "../job.model";
import {
  Component,
  OnInit,
  Input,
  ViewChildren,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
  TemplateRef,
  SimpleChanges,
  SimpleChange,
  ElementRef,
  ChangeDetectionStrategy,
  Renderer2,
  OnDestroy,
  DestroyRef,
  inject,
  computed,
  EventEmitter,
  Output,
} from "@angular/core";
import moment from "moment";
import { HotToastService } from "@ngneat/hot-toast";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { Router } from "@angular/router";
import * as _ from "underscore";
import { DragulaService, DragulaModule } from "ng2-dragula";
import { AccountantService } from "../../accountant.service";
import { MentionDirective, MentionModule } from "angular-mentions";
import { RealTimeService } from "../../../common/notifications/real-time.service";
import { runInThisContext } from "vm";
import { TelemetryService } from "src/app/dashboard/telemetry.service";
import { JobTimeTrackingService } from "../time-tracking/job-time-tracking-modal/job-time-tracking.service";
import { TimerService } from "./../time-tracking/timer/timer.service";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
import { StartTimerFromPreviousEntryModalComponent } from "../time-tracking/start-timer-from-previous-entry-modal/start-timer-from-previous-entry-modal.component";
import { PinnedService } from "../../pinned-panel/pinned.service";
import {
  PinnedModels,
  PinnedModelsApps,
} from "../../pinned-panel/pinned-models";
import { NotesService } from "../../notes/notes.service";
import { EmailContentComponent } from "src/app/dashboard/email/email-content/email-content.component";
import { GenericDrawerService } from "src/app/dashboard/drawer/global-drawer.service";
import { HistoryFormatterPipe } from "./history-formatter.pipe";
import { ActiveClientsOnlyPipe } from "../../../common/active-clients-only.pipe";
import { MomentModule } from "ngx-moment";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { JobUploadFileComponent } from "./job-upload-file/job-upload-file.component";
import { TrackedItemBubbleComponent } from "../../../../conversations/tracked-item-bubble/tracked-item-bubble.component";

import { MessageBubbleComponent } from "../../../../conversations/message-bubble/message-bubble.component";
import { TagAddComponent } from "../../../common/tags/tag-add/tag-add.component";
import { TagComponent } from "../../../common/tags/tag.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AutosizeModule } from "ngx-autosize";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgClass, NgStyle, CommonModule } from "@angular/common";
import { Editor, EditorModule } from "primeng/editor";

import { ProgressSpinnerModule } from "primeng/progressspinner";
import {
  PERMISSION_JOBS_JOB_DELETE,
  PERMISSION_JOBS_JOB_EDIT_DATE,
  ROLE_ADMIN,
  ROLE_STAFF,
  UserPermissions,
} from "src/app/services/authorization/authorization.models";
import { PinComponent } from "src/app/design-system/components/pin/pin.component";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DatePickerModule } from "primeng/datepicker";
import { DateOffsetPickerComponent } from "../date-offset-picker/date-offset-picker.component";
import { JobNotificationService } from "../../shared/job-notification.service";

interface IHistory {
  id: number;
  user: string;
  object_name: string;
  action_verbose: string;
  uuid: string;
  type: number;
  action: string;
  action_dt: string;
  diff: string;
  object_id: string;
  reference_id: string;
  client_company: number;
  accounting_company: number;
}

@Component({
  selector: "app-job-content",
  templateUrl: "./job-content.component.html",
  styleUrls: ["./job-content.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TooltipModule,
    FormsModule,
    AutosizeModule,
    NgClass,
    BsDropdownModule,
    NgStyle,
    TagComponent,
    TagAddComponent,
    DragulaModule,
    MessageBubbleComponent,
    TrackedItemBubbleComponent,
    JobUploadFileComponent,
    MentionModule,
    TypeaheadModule,
    MomentModule,
    ActiveClientsOnlyPipe,
    HistoryFormatterPipe,
    EditorModule,
    ProgressSpinnerModule,
    PinComponent,
    DatePickerModule,
  ],
})
export class JobContentComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly ROLE_STAFF = ROLE_STAFF;
  readonly ROLE_ADMIN = ROLE_ADMIN;
  readonly PERMISSION_JOBS_JOB_DELETE = PERMISSION_JOBS_JOB_DELETE;
  readonly PERMISSION_JOBS_JOB_EDIT_DATE = PERMISSION_JOBS_JOB_EDIT_DATE;

  readonly JOB_STATUSES = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    ON_HOLD: 2,
    COMPLETED: 3,
  } as const;

  readonly RECURRENCE_TYPES = {
    WEEKLY: 0,
    MONTHLY: 1,
    DAILY: 3,
  } as const;

  isLoading = false;
  pinModel = PinnedModels.Job;

  repeat = false;
  showRepeatModal = false;
  bsModalRef: BsModalRef;
  reassignModalRef: BsModalRef; // Created to fix an issue with two modals being opened at the same time
  newClientTaskModalRef?: BsModalRef;

  activeTab = "tasks";
  historyLoading = false;
  commentsLoading = false;
  accountants = null;
  comments = [];
  message = "";
  isTrackingTime: boolean = true;
  hasCompletedTracking: boolean = false;
  totalTimeTracked;

  _accountants: any[];

  @Input() job: Job;
  @Input() templateManager: boolean = false;
  @ViewChild("jobsCommentWrapper") private jobsCommentWrapper: ElementRef;
  @ViewChild(MentionDirective) mention: MentionDirective;

  @ViewChild("pEditor") public editor: any;

  @ViewChildren("taskEl") tasks;
  @ViewChildren("taskGroupEl") tasksGroups;
  @ViewChild("jobName", { static: false }) jobName: ElementRef;
  modalRef: BsModalRef;
  @ViewChild("completedConfirmation", { static: false })
  completedConfirmationModal: TemplateRef<any>;
  isCompletedConfirmationModalOpen = false;

  @ViewChild("toggleButtonBellMenu") toggleButtonBellMenu: ElementRef;
  @ViewChild("bellMenu") bellMenu: ElementRef;

  @ViewChild("reassignJobModal")
  private reassignJobModal: TemplateRef<any>;

  @ViewChild("markAsInProgressModal")
  private markAsInProgressModal: TemplateRef<any>;

  @ViewChild("historyModal")
  private historyModal: TemplateRef<any>;

  jobTasksCompleted = false;

  taskItemPickerVisible = false;

  datepickerFormat = "mm-dd-yy";

  allowTaskGroupDrag = true;
  allowTaskDrag = true;

  selectedElement: Task | TaskGroup = null;

  duplicateSelected: string;
  duplicateSelectedObj = null;

  originalRecurrenceOptions = {};
  imageUploadUrl = `${environment.apiUrl}/file-manager/`;

  subs = new Subscription();

  autopilot: boolean;
  autopilotIn = 1;

  user: any = null;
  data: any = null;

  userPermissions: UserPermissions;

  showAccountants = false;
  currentGroupName: string = "";

  public iframe: object = { enable: true };
  public height: number = 500;

  readonly destroyRef = inject(DestroyRef);

  @Output() jobDeleted = new EventEmitter<void>(); // Event emitter for job deletion

  constructor(
    public jobsService: JobsService,
    public jobsStore: JobsStore,
    private modalService: BsModalService,
    public dashboardStore: DashboardStore,
    public toastr: HotToastService,
    private router: Router,
    private localStorage: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private dragulaService: DragulaService,
    private dashboardService: DashboardService,
    private conversationsService: ConversationsService,
    private accountantService: AccountantService,
    private renderer: Renderer2,
    private realTimeService: RealTimeService,
    private telemetryService: TelemetryService,
    private jobTimeTrackingService: JobTimeTrackingService,
    public timerService: TimerService,
    public sharedDataService: SharedDataService,
    private pinnedService: PinnedService,
    private notesService: NotesService,
    private genericDrawerService: GenericDrawerService,
    private jobNotificationService: JobNotificationService, // Inject the shared service
  ) {
    this.saveOrCreateTask = _.debounce(this.saveOrCreateTask, 50);
    this.saveOrCreateTaskGroup = _.debounce(this.saveOrCreateTaskGroup, 100);
    this.saveOrCreateByJob = _.debounce(this.saveOrCreateByJob, 500);
    this.onBlur = _.debounce(this.onBlur, 1000);
    this.user = this.localStorage.get("user");

    this.renderer.listen("window", "click", (e: Event) => {
      if (
        !this.toggleButtonBellMenu?.nativeElement.contains(e.target) &&
        !this.bellMenu?.nativeElement.contains(e.target)
      ) {
        this.showAccountants = false;
        this.cdr.detectChanges();
      }
    });
  }

  actionStyle(action: string) {
    const ac = action.toLowerCase();
    if (ac.includes("create")) {
      return "created";
    }
    if (ac.includes("update")) {
      return "updated";
    }
    if (ac.includes("delete")) {
      return "deleted";
    }
  }

  parseDiff(diff: string) {
    const differencesJson = JSON.parse(diff);
    if (differencesJson == null) {
      return "";
    }
    if (differencesJson.length == 1 && differencesJson[0][0] == "id") {
      // obj created
      return "";
    }
    const differences = differencesJson.map((d: any) => {
      return { field: d[0], before: d[1][0], after: d[1][1] };
    });
    return differences;
  }

  async openTimeTrackingModal(
    client_company: Company,
    job: Job,
    userId: number,
  ) {
    try {
      const status = await this.dashboardService.timeTrackingStatus();
      const { time_tracking_status } = status || {};

      if (time_tracking_status) {
        await this.timerService.timerPause();

        this.bsModalRef = this.modalService.show(
          StartWithOngoingEntryModalComponent,
          {
            initialState: {
              jobName: time_tracking_status.job.name,
              company: time_tracking_status.job.client_company.name,
            },
          },
        );

        this.bsModalRef.content.onClose.subscribe((res: boolean) => {
          if (res) {
            this.openStartFromPreviousEntry();
          } else {
            this.timerService.timerResume();
          }
        });
      } else {
        this.openStartFromPreviousEntry();
      }
    } catch (err) {
      this.toastr.error("Failed to fetch or update time tracking status.");
      console.error(err);
    }
  }

  async openStartFromPreviousEntry() {
    try {
      const { previous_entry_time_tracked } =
        await this.jobTimeTrackingService.checkPreviousEntry(this.job.uuid);

      if (previous_entry_time_tracked === 0) {
        // No previous entry time – start a fresh tracking session
        this.bsModalRef = this.modalService.show(
          JobTimeTrackingModalComponent,
          {
            initialState: {
              job: this.job,
              clientCompany: this.job.client_company,
            },
          },
        );
        this.cdr.detectChanges();
      } else {
        this.bsModalRef = this.modalService.show(
          StartTimerFromPreviousEntryModalComponent,
          {
            initialState: {
              jobName: this.job.name,
              currentTimeTracked: previous_entry_time_tracked,
            },
          },
        );

        this.bsModalRef.content.onClose.subscribe(async (res: boolean) => {
          if (res) {
            await this.jobTimeTrackingService.startTimeTracking(
              { is_new: false },
              this.job.uuid,
            );
            this.toastr.success(
              `Time tracking started for job ${this.job.name}`,
            );
            this.jobTimeTrackingService.isTracking.next(true);
            this.dashboardService.startTimeTracking.next({
              is_paused: false,
              current_time: previous_entry_time_tracked,
              job: this.job,
            });
          } else {
            this.bsModalRef = this.modalService.show(
              JobTimeTrackingModalComponent,
              {
                initialState: {
                  job: this.job,
                  clientCompany: this.job.client_company,
                },
              },
            );
          }
        });
      }
    } catch (err) {
      this.toastr.error("Failed to check for previous entry time.");
      console.error(err);
    }
  }

  openHistoryModal(jobUuid: string) {
    this.historyLoading = true;
    this.telemetryService.getHistoryByReferenceId(jobUuid).subscribe(
      (data) => {
        const history = data.map((d: IHistory) => {
          return {
            ...d,
            differences: this.parseDiff(d.diff),
            action_verbose: d.action_verbose.toLowerCase(),
            action_style: this.actionStyle(d.action_verbose),
          };
        });

        this.bsModalRef = this.modalService.show(this.historyModal, {
          class: "modal-lg",
        });
        this.bsModalRef.content = {
          history,
        };
        this.historyLoading = false;
      },
      (err) => {
        this.historyLoading = false;
        console.error(err);
      },
    );
  }

  calculateDate(date: Date, days: number) {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    return result;
  }

  calculateDueDate(date: string, days: number) {
    return this.calculateDate(new Date(date), days);
  }

  isAutopilotAvailable() {
    if (this.job.is_master_template) {
      return false;
    }

    const tgs = this.job.task_groups;
    if (typeof tgs != null && tgs.length > 0) {
      const ts = tgs[0].tasks;
      if (typeof ts != null && ts.length > 0) {
        const t = ts[0];
        if (
          t &&
          t.name !== "" &&
          t.related_tracked_item &&
          t.related_tracked_item["uuid"] != null
        ) {
          return true;
        }
      }
    }

    // // ensure no autopilot is set
    // if (this.job.autopilot_publish_date) {
    //   this.job.autopilot_publish_date = null;
    //   this.autopilot = false;
    //   this.saveOrCreateByJob(this.job);
    // }
    return false;
  }

  toggleAutopilot(autopilotModal) {
    if (this.job.autopilot_days != null) {
      this.autopilotIn = this.job.autopilot_days;
    } else {
      this.autopilotIn = 0;
    }

    if (this.autopilot) {
      this.openAutoPilotModal(autopilotModal);
    }

    this.saveOrCreateByJob(this.job);
  }

  setAutopilotIn(days: any) {
    this.autopilotIn = Number(days);
    this.job.autopilot_days = this.autopilotIn;
    this.job.autopilot_publish_date = this.calculateDate(
      new Date(this.job.target_start_date),
      days,
    );
  }

  forceSaveAutopilot(modal: any) {
    modal.hide();
    this.saveOrCreateByJob(this.job);
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData("text");
    pastedText = pastedText.replace(/(<([^>]+)>)/gi, "");

    event.preventDefault();
    document.execCommand("insertText", false /*no UI*/, pastedText);
  }

  keyHandler(e) {
    e.keyCode === 13 ? e.preventDefault() : "";
  }

  setEndOfContenteditable(contentEditableElement) {
    var range, selection;
    if (document.createRange) {
      //Firefox, Chrome, Opera, Safari, IE 9+
      range = document.createRange(); //Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
      range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection(); //get the selection object (allows you to change selection)
      selection.removeAllRanges(); //remove any selections already made
      selection.addRange(range); //make the range you have just created the visible selection
    }
  }

  /* 
    using ngOnChanges to get the job change via input
    this is being used to set the cursor on the jobName input
    and creating a new blank task at the end if the job was
    already created
  */
  async ngOnChanges(changes: SimpleChanges) {
    if (this.sharedDataService.subscriptionType == "free") return;

    try {
      this.activeTab = "tasks";
      this.isTrackingTime = null;
      let autopilotStatus = this.autopilot;
      this.autopilotIn = null;
      let _changes = changes.job;

      let oldJob = JSON.parse(JSON.stringify(this.job));

      let newJob = _changes.currentValue;
      this.job = newJob;

      if (oldJob != null) {
        if (newJob.uuid != oldJob.uuid) {
          oldJob["autopilot"] = autopilotStatus;
          await this.saveOrCreateByJob(oldJob);
        }
      }

      // fill the dropdowns where you can select accountants to assign, both on Job and TaskGroup
      if (this.job.client_company != null) {
        let client_company_id =
          typeof this.job.client_company == "number"
            ? this.job.client_company
            : this.job.client_company["id"];

        this.getAccountants(client_company_id).then((accountants: any[]) => {
          this._accountants = accountants;
        });
      }

      if (this.templateManager) {
        this._accountants = this.jobsStore.company.accountants;
      }

      if (this.job.uuid != null) {
        this.selectedElement = null;
        if (this.job.uuid.length > 10) {
          // get job from backend
          // document.getElementsByClassName("job-panel")[0].classList.add("component-loading");
          this.isLoading = true;
          this.jobsService.getJob(this.job.uuid).then(
            (job: Job) => {
              if (job.uuid == this.job.uuid) {
                console.log("got job from backend", job);

                let selected = job["selected"];
                this.job = job;
                this.job["selected"] = selected;

                this.cdr.detectChanges();
                this.isAutopilotAvailable();
                this.cdr.detectChanges();

                this.isLoading = false;

                setTimeout(() => {
                  this.setEndOfContenteditable(this.jobName.nativeElement);
                }, 50);

                if (this.job.autopilot_publish_date != null) {
                  this.autopilot = true;
                } else {
                  this.autopilot = false;
                }

                if (this.autopilot) {
                  if (this.job.autopilot_days != null) {
                    this.autopilotIn = this.job.autopilot_days;
                  } else {
                    this.autopilotIn = Math.round(
                      Math.floor(
                        new Date(this.job.target_start_date).getTime() -
                          new Date(this.job.autopilot_publish_date).getTime(),
                      ) /
                        (1000 * 60 * 60 * 24),
                    );
                    console.log("autopilot in", this.autopilotIn);
                  }
                }

                // load accountants for mention in messages
                this.getStaffMembers();

                this.cdr.detectChanges();

                this.checkJobTasksCompletion();

                this.checkTimeTracking();

                this.jobTimeTrackingService.updateTotalTimeTracked.subscribe(
                  (res) => (this.totalTimeTracked = res),
                );

                this.realTimeService.conversationUpdates$
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe((res: { tracked_item: any }) => {
                    for (let x = 0; x < this.job.task_groups.length; x++) {
                      for (
                        let y = 0;
                        y < this.job.task_groups[x].tasks.length;
                        y++
                      ) {
                        if (
                          this.job.task_groups[x].tasks[y].related_tracked_item
                        ) {
                          if (
                            this.job.task_groups[x].tasks[y]
                              .related_tracked_item.uuid ==
                            res.tracked_item.uuid
                          ) {
                            this.job.task_groups[x].tasks[
                              y
                            ].related_tracked_item = res.tracked_item;
                          }
                        }
                      }
                    }
                  });

                // Once again using setTimeout to guarantee the elements are loaded
                // before setting the cursor at the end
                if (this.job.uuid.length < 10) {
                  setTimeout(() => {
                    let elem = document.getElementById("jobName");
                    this.setEndOfContenteditable(elem);
                  }, 100);
                }

                this.message = "";
                this.comments = [];
                if (this.job.uuid != null) {
                  this.jobsService
                    .getJobComments(this.job.uuid)
                    .subscribe(
                      (res) => this.handleCommentsResponse(res),
                      (err) => this.handleError(err.message, err),
                    )
                    .add(() => {
                      // this.commentsLoading = false;
                      this.scrollToEnd();
                    });

                  this.realTimeService.setJobNotificationsListener(
                    this.job.uuid,
                  );
                  this.realTimeService.jobCommentNotifications
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe((msg: any) => {
                      if (msg?.text) this.addComment(msg);
                      // else this.getJobComments();
                      this.cdr.markForCheck();
                      this.cdr.detectChanges();
                    });
                }
              }
            },
            (error) => {
              console.log(error);
            },
          );
        } else {
          setTimeout(() => {
            this.jobName.nativeElement.focus();
          });
        }

        // if (this.jobName != null) {
        //   this.jobName.nativeElement.focus();
        // }
      }
    } catch (e) {
      console.log(e);
    }
  }

  ngOnDestroy() {
    // destroy all the subscriptions at once
    this.subs.unsubscribe();
    this.dragulaService.destroy("TASKS");
    this.dragulaService.destroy("TASK_GROUPS");
  }

  ngOnInit(): void {
    this.data = this.localStorage.get("data");
    this.userPermissions = this.localStorage.get("userPermissions");

    this.getStaffMembers();

    this.dragulaService.createGroup("TASK_GROUPS", {
      moves: (el, source, handle, sibling): any => {
        if (handle.classList.contains("drag-handle-taskgroup")) {
          return true;
        } else {
          return false;
        }
      },
    });

    this.dragulaService.createGroup("TASKS", {
      moves: (el, source, handle, sibling): any => {
        if (handle.classList.contains("drag-handle-task")) {
          return true;
        } else {
          return false;
        }
      },
    });

    this.subs.add(
      this.dragulaService
        .dropModel("TASK_GROUPS")
        .subscribe(({ targetModel }) => {
          this.allowTaskDrag = true;
          this.allowTaskGroupDrag = true;
          this.job.task_groups = targetModel;

          if (this.job.task_groups.length > 1) {
            let order = 0;
            this.job.task_groups.forEach((v) => {
              v.order = order;
              order++;
            });

            let data = this.job.task_groups.map((tg) => {
              return { uuid: tg.uuid, order: tg.order };
            });

            data = data.filter((tg) => tg.uuid.length > 10);

            this.jobsService
              .updateTaskGroupOrder(this.job.uuid, data)
              .subscribe(
                (res) => {},
                (err) => {
                  this.toastr.error(err.error.message);
                },
              );
            console.log("this.jog after drop", this.job);
          }
        }),
    );

    this.subs.add(
      this.dragulaService
        .dropModel("TASKS")
        .subscribe(
          ({ targetModel, target, sourceModel, name, source, sibling }) => {
            let tasks = targetModel;
            if (tasks.length > 1) {
              let order = 0;
              tasks.forEach((t) => {
                t.order = order;
                order++;
              });

              let data = tasks.map((t) => {
                return {
                  uuid: t.uuid,
                  order: t.order,
                  task_group: t.task_group,
                };
              });

              let filtered_data = data.filter((t) => t.uuid.length > 10);

              this.jobsService
                .updateTaskOrder(
                  this.job.uuid,
                  target.parentNode["id"],
                  filtered_data,
                )
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(
                  (res) => {},
                  (err) => {
                    this.toastr.error(err.error.message);
                  },
                );
            }
          },
        ),
    );

    this.jobTimeTrackingService.isTracking
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: boolean) => {
        this.isTrackingTime = res;
        this.checkTimeTracking();
        this.cdr.detectChanges();
      });
  }

  pEditorOnInit(event, selectedElement, taskGroup) {
    this.editor = event.editor;

    this.editor.root.addEventListener("blur", () => {
      if (selectedElement.type == "task") {
        this.onBlur(selectedElement, taskGroup);
      } else {
        this.onBlur(selectedElement);
      }
    });
  }

  onEditorTextChange(event, selectedElement, taskGroup) {
    if (selectedElement.type == "task") {
      this.onBlur(selectedElement, taskGroup);
    } else {
      this.onBlur(selectedElement);
    }
  }

  ngAfterViewInit() {}

  async getAccountants(clientCompanyId: number) {
    const { accountants } =
      await this.jobsService.getAccountantsFromClientCompany(clientCompanyId);
    return accountants;
  }

  async saveOrCreateByJob(job: Job) {
    if (!this.job.is_master_template) {
      if (this.job.uuid.length < 10) {
        if (this.job.name != "") {
          this.jobsService.createJob(this.job).subscribe((res) => {
            let description = this.job.description;
            Object.assign(this.job, <Job>res.job);
            this.job.description = description;
            this.job.task_groups[0].tasks.push(new Task());
            this.cdr.detectChanges();
            this.checkTimeTracking();
          });
        }
      } else {
        if (job.uuid) {
          console.log(
            `%c JOB SAVE BY ID - ${job.uuid}`,
            "font-size: 24px; color: red",
          );
          console.log("jobSaveOrCreate", job);
          if (job.status == 3) {
            this.dashboardService.show_loading.next(true);
          }

          if (this.isTrackingTime === true && this.job.status === 3) {
            this.timerService.timerStop();
            this.toastr.warning(
              `Timer stopped for job ${this.job.name} due to it's completed status.`,
            );
          }

          this.job["autopilot"] = this.autopilot;

          // create a copy of the job object without the task_groups so
          // the payload size is smaller
          let job_copy = Object.keys(job)
            .filter((objKey) => objKey !== "task_groups")
            .reduce((newObj, key) => {
              newObj[key] = job[key];
              return newObj;
            }, {}) as Job;

          let res = await this.jobsService.saveJob(job_copy);

          let groups = this.job.task_groups;

          job.modified_date = res.job.modified_date;
          job.assigned_to = res.job.assigned_to;
          this.job.task_groups = groups;

          this.jobsService.jobContentChanged.next(job);
          // if a recurring_job was created because of the save:
          if (res.new_job) {
            this.jobsService.newRecurringJob.next(<Job>res.new_job);
          }

          if (res.daily_jobs_created) {
            this.jobsStore.reloadJobs$.next(null);
          }

          this.dashboardService.show_loading.next(false);
        }
      }
    }
  }

  saveOrCreateTaskGroup(task_group: TaskGroup): void {
    let old_tasks = task_group.tasks;

    if (task_group.uuid.length < 10) {
      if (task_group.name != "" && task_group.name != null) {
        this.jobsService
          .createTaskGroup(this.job, task_group)
          .subscribe((res) => {
            Object.assign(task_group, <TaskGroup>res.task_group);
            task_group.tasks = old_tasks;
            this.jobsService.jobContentChanged.next(this.job);
          });
      }
    } else {
      task_group.saving = true;
      this.cdr.detectChanges();
      // create a copy of the job object without the task_groups so
      // the payload size is smaller
      let task_group_copy = Object.keys(task_group)
        .filter((objKey) => objKey !== "tasks")
        .reduce((newObj, key) => {
          newObj[key] = task_group[key];
          return newObj;
        }, {}) as TaskGroup;

      this.jobsService.saveTaskGroup(task_group_copy).subscribe((res) => {
        // TODO: remove the serializer in the backend and only return the needed data
        Object.assign(task_group, <TaskGroup>res.task_group);
        task_group.saving = false;
        this.cdr.detectChanges();
        task_group.tasks = old_tasks;
        this.jobsService.jobContentChanged.next(this.job);
      });
    }
  }

  saveOrCreateTask(task_group: TaskGroup, task: Task): void {
    if (task.uuid.length < 10) {
      if (task.name != "" && task.name != null) {
        this.jobsService.createTask(task_group, task).subscribe((res) => {
          Object.assign(task, <Task>res.task);
          this.jobsService.jobContentChanged.next(this.job);
          this.cdr.detectChanges();
        });
      } else {
        if (task_group != null) {
          task_group.tasks = task_group.tasks.filter(
            (t) => t.uuid != task.uuid,
          );
        }
      }
    } else {
      task.saving = true;
      this.cdr.detectChanges();
      this.jobsService.saveTask(task).subscribe((res) => {
        task.saving = false;
        this.cdr.detectChanges();
        if (res.current_group) {
          this.job.current_group = res.current_group;
        }
        this.jobsService.jobContentChanged.next(this.job);
        this.checkJobTasksCompletion();
        this.cdr.detectChanges();
      });
    }
  }

  /*
    Called when task status changes
  */
  changeTaskStatus(task, task_group) {
    if (!this.templateManager) {
      task.completed = !task.completed;

      this.saveOrCreateTask(task_group, task);

      //check if all tasks in group are completed
      let all_tasks_completed = true;
      task_group.tasks.forEach((t) => {
        if (!t.completed) {
          all_tasks_completed = false;
        }
      });

      if (all_tasks_completed) {
        // check if the next task_group has open tasks
        const next_task_group = this.job.task_groups.find(
          (tg) => tg.order == task_group.order + 1,
        );
        if (next_task_group) {
          const open_tasks = next_task_group.tasks.filter((t) => !t.completed);

          if (open_tasks.length > 0) {
            // check if the group owner is different than the job assigned_to
            if (
              this.job.assigned_to != null &&
              next_task_group.owner != null &&
              this.job.assigned_to["id"] != next_task_group.owner["id"]
            ) {
              // prompt the user if the job should be reassigned to the next task group owner
              this.reassignModalRef = this.modalService.show(
                this.reassignJobModal,
                {
                  class: "modal-sm",
                  initialState: { user: next_task_group.owner },
                },
              );

              this.reassignModalRef.content = {
                user: next_task_group.owner,
              };
            }
          }
        }
      }

      // check this to show the modal where it asks to move the job status
      // to In Progress

      let tasks_completed = 0;
      let task_count = 0;
      this.job.task_groups.forEach((tg) => {
        tg.tasks.forEach((t) => {
          task_count++;
          if (t.completed) {
            tasks_completed++;
          }
        });
      });

      if (tasks_completed == 1 && this.job.status != 1 && task_count > 1) {
        this.bsModalRef = this.modalService.show(this.markAsInProgressModal, {
          class: "modal-sm",
          initialState: {},
        });
      }
    }
  }

  reassignJob(job, user) {
    job.assigned_to = user;
    this.saveOrCreateByJob(job);
    this.cdr.detectChanges();
    this.reassignModalRef.hide();
  }

  handleTaskPress(ev, task_group: TaskGroup, task: Task) {
    // Event when # is pressed
    if (ev.keyCode == 51 && ev.shiftKey && this.selectedElement?.name == "") {
      ev.preventDefault();

      this.addEmptyTaskGroup(task_group);
    }

    if (ev.keyCode == 191 && this.selectedElement.name == "") {
      this.taskItemPickerVisible = true;
      this.launchTrackedItemsModal(task_group);
    }

    // Event when Tab is pressed
    // if (ev.keyCode == 9) {
    //   this.selectedElement = null;
    // }

    // Event when Enter or Tab is pressed
    if (ev.keyCode == 13 || ev.keyCode == 9) {
      ev.preventDefault();

      // check if previous element is empty and prevent the new
      // task to be created
      if (task_group.tasks.length > 0) {
        if (task_group.tasks[task_group.tasks.length - 1].name == "") {
          return;
        }
      }
      // Push a new task to the current task group

      task_group.tasks.push(new Task());

      this.setSelectedElement(
        task_group.tasks[task_group.tasks.length - 1],
        "task",
        task_group,
      );

      setTimeout(() => {
        this.tasks.forEach((t) => {
          if (t.nativeElement.id == `task-${this.selectedElement?.uuid}`) {
            t.nativeElement.focus();
          }
        });
      }, 250);
    }

    /*
      this section is used to create an empty task
      after the user starts typing in the last one
    */
    // if (task) {
    //   if (task_group.tasks[task_group.tasks.length - 1].uuid == task.uuid) {
    //     if (task_group.tasks[task_group.tasks.length - 1].name.length > 0) {
    //       task_group.tasks.push(new Task());
    //     }
    //   }
    // }
  }

  private addEmptyTaskGroup(task_group: TaskGroup) {
    // Push a new task_group
    this.job.task_groups.push(new TaskGroup());

    // Remove last element
    // task_group.tasks = task_group.tasks.filter((t) => {
    //   return t.uuid != this.selectedElement?.uuid;
    // });

    // Set the new task_group as the selected element
    this.setSelectedElement(
      this.job.task_groups[this.job.task_groups.length - 1],
      "taskgroup",
    );

    setTimeout(() => {
      this.tasks.forEach((t) => {
        if (t.nativeElement.id == `task-${this.selectedElement?.uuid}`) {
          t.nativeElement.focus();
        }
      });
    }, 250);
  }

  /* 
  Sets the selected element 
  (it is the element on the right sliding panel) 
  */
  setSelectedElement(el, type, group = null) {
    setTimeout(() => {
      el.type = type;
      this.selectedElement = el;
      this.cdr.detectChanges();
    }, 100);
  }

  selectDate(ev, target, field) {
    let dt = moment(ev);
    console.log(dt);
    // adjust autopilot date
    if (field === "target_start_date") {
      this.job.autopilot_publish_date = this.calculateDate(
        new Date(this.job.target_start_date),
        this.autopilotIn,
      );
    }
    if (field == "target_start_date" && dt.isAfter(this.job.due_date, "day")) {
      this.job.due_date = this.job.target_start_date;
    } else if (
      field == "due_date" &&
      dt.isBefore(this.job.target_start_date, "day")
    ) {
      this.job.target_start_date = this.job.due_date;
    }

    this.saveOrCreateByJob(this.job);
  }

  selectAssignee(accountant) {
    this.job.assigned_to = accountant.user;
    this.saveOrCreateByJob(this.job);
  }

  selectTemplateAssignee(accountant) {
    this.job.assigned_to = accountant.user;
  }

  selectJobStartingOwner(accountant) {
    this.job.starting_owner = accountant.user;
  }

  // function to set the task group owner
  selectTaskGroupOwner(task_group, user) {
    task_group.owner = user;
    this.saveOrCreateTaskGroup(task_group);
  }

  /*
   * Check if all tasks on job are complete
   * and prompts user to mark job as complete
   */
  checkJobTasksCompletion() {
    // if there are no task groups, dont check
    if (!(this.job?.task_groups?.length > 0)) {
      return;
    }
    if (this.job.status != 3) {
      let hasTasks = false;
      let tasksDone = true;
      this.job.task_groups.forEach((taskGroup, index) => {
        taskGroup.tasks.forEach((task) => {
          hasTasks = true;
          if (tasksDone) {
            if (!task.completed) {
              tasksDone = false;
            }
          }
        });
      });
      if (hasTasks && tasksDone) {
        this.jobTasksCompleted = true;

        this.cdr.detectChanges();
        // this.completedConfirmationModal.show();
        if (!this.isCompletedConfirmationModalOpen) {
          this.bsModalRef = this.modalService.show(
            this.completedConfirmationModal,
            {
              class: "modal-sm",
              initialState: {},
            },
          );

          this.bsModalRef.onHide.subscribe(() => {
            this.isCompletedConfirmationModalOpen = false;
          });

          this.isCompletedConfirmationModalOpen = true;
        }
      } else {
        this.jobTasksCompleted = false;
      }
    }
  }

  markAsCompleted() {
    this.job.status = 3;
    this.saveOrCreateByJob(this.job);
    this.cdr.detectChanges();
    this.bsModalRef.hide();
    (document.querySelector(".modal-backdrop") as HTMLElement).style.display =
      "block";
    if (this.isTrackingTime === true && this.job.status === 3) {
      this.timerService.timerStop();
      this.toastr.warning(
        `Timer stopped for job ${this.job.name} due to it's completed status.`,
      );
    }

    this.dashboardService.closeJobDrawer$.next(true);
  }

  markAsInProgress() {
    this.job.status = 1;
    this.saveOrCreateByJob(this.job);
    this.bsModalRef.hide();
    (document.querySelector(".modal-backdrop") as HTMLElement).style.display =
      "block";
  }

  checkTaskCompletion(taskGroup: TaskGroup) {
    return (
      taskGroup.tasks.filter((t) => t.completed && t.uuid.length > 5).length ==
      taskGroup.tasks.filter((t) => t.uuid.length > 5).length
    );
  }

  openAutoPilotModal(template: TemplateRef<any>): void {
    if (this.autopilot) {
      this.bsModalRef = this.modalService.show(template, { class: "modal-lg" });
    }
  }

  openRemoveTaskModal(template: TemplateRef<any>): void {
    this.bsModalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  openRemoveTaskGroupModal(template: TemplateRef<any>): void {
    this.bsModalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  openRepeatModal(template: TemplateRef<any>): void {
    if (!this.job.recurrence_options["adjust_start_date"]) {
      this.job.recurrence_options["adjust_start_date"] = 0;
    }

    if (this.job.starting_owner == null) {
      this.job.starting_owner = this.job.assigned_to;
    }

    this.originalRecurrenceOptions = _.clone(this.job.recurrence_options);
    this.bsModalRef = this.modalService.show(template, {
      class: "modal-md",
      ignoreBackdropClick: true,
    });
  }

  closeRepeatModal() {
    this.job.recurrence_options = this.originalRecurrenceOptions;
    this.bsModalRef.hide();
  }

  deleteTask(task: Task) {
    this.jobsService.deleteTask(task).subscribe((res) => {
      this.job.task_groups.forEach((tg) => {
        if (tg.id == task.task_group) {
          tg.tasks = tg.tasks.filter((t) => t.uuid !== task.uuid);
        }

        this.cdr.detectChanges();
      });
      this.toastr.success(res.message);
      this.bsModalRef.hide();
    });
  }

  deleteTaskGroup(task_group: TaskGroup) {
    this.jobsService.deleteTaskGroup(task_group).subscribe((res) => {
      this.job.task_groups = this.job.task_groups.filter((tg) => {
        return tg.uuid != task_group.uuid;
      });

      // Create an empty task group if none is left
      if (this.job.task_groups.length == 0) {
        this.job.task_groups.push(new TaskGroup());
      }

      this.toastr.success(res.message);
      this.bsModalRef.hide();
    });
  }

  addTaskPanel(e) {
    if (e.target.className == "left-form") {
      // Check if last task of last task group has something written
      // if it doesnt, dont create a new task
      if (
        this.job.task_groups[this.job.task_groups.length - 1].tasks.length >
          0 &&
        this.job.task_groups[this.job.task_groups.length - 1].tasks[
          this.job.task_groups[this.job.task_groups.length - 1].tasks.length - 1
        ].uuid.length != 5
      ) {
        // Push a new task to the last task group
        this.job.task_groups[this.job.task_groups.length - 1].tasks.push(
          new Task(),
        );

        // Set it as the selectedElement
        this.setSelectedElement(
          this.job.task_groups[this.job.task_groups.length - 1].tasks[
            this.job.task_groups[this.job.task_groups.length - 1].tasks.length -
              1
          ],
          "task",
          this.job.task_groups[this.job.task_groups.length - 1],
        );

        // Focus on the html element
        setTimeout(() => {
          this.tasks.forEach((t) => {
            if (t.nativeElement.id == `task-${this.selectedElement?.uuid}`) {
              t.nativeElement.focus();
            }
          });
        }, 250);
      }
    }
  }

  openDuplicateJobModal(template: TemplateRef<any>, job): void {
    this.bsModalRef = this.modalService.show(template, {
      class: "duplicate-job-modal modal-sm",
    });
  }

  openCreateJobModal(template: TemplateRef<any>, job): void {
    job.target_start_date = moment(new Date(), "MM-DD-YYYY");
    job.due_date = moment(new Date(), "MM-DD-YYYY");

    if (this.templateManager) {
      this._accountants = this.jobsStore.company.accountants;
    }

    this.bsModalRef = this.modalService.show(template, {
      class: "duplicate-job-modal modal-sm",
    });
  }

  duplicateJob(override_params = {}, should_redirect = true) {
    this.isLoading = true;

    if (override_params["is_template"] != null) {
      this.duplicateSelectedObj = { id: null };
    }

    if (this.autopilot) {
      let autopilot_publish_date = this.calculateDate(
        new Date(this.job.target_start_date),
        this.autopilotIn,
      );

      override_params["autopilot_publish_date"] = autopilot_publish_date;

      override_params["autopilot_days"] = this.autopilotIn;
    }

    console.log("Override Parameters:", override_params);

    if (override_params["target_start_date"] != null) {
      override_params["target_start_date"] = moment(
        override_params["target_start_date"],
      ).format("YYYY-MM-DD");
    }

    if (override_params["due_date"] != null) {
      override_params["due_date"] = moment(override_params["due_date"]).format(
        "YYYY-MM-DD",
      );
    }

    this.jobsService
      .duplicateJob(
        this.job.uuid,
        this.duplicateSelectedObj.id,
        override_params,
      )
      .subscribe((res) => {
        let _job = <Job>res.job;
        this.isLoading = false;

        this.toastr.success(res.message);

        this.cdr.detectChanges();

        if (!this.templateManager) {
          if (_job.client_company["id"] == this.job.client_company["id"]) {
            this.jobsService.newRecurringJob.next(_job);
            this.jobsStore.changeSelectedJob.next(_job);
          } else {
            if (should_redirect) {
              this.router.navigate(
                [
                  `./${
                    this.localStorage.get("data")["user_type"] == 1
                      ? "practice"
                      : "client"
                  }/workspaces`,
                  _job.client_company["id"],
                  "jobs",
                ],
                {
                  queryParams: {
                    job: _job.uuid,
                  },
                  queryParamsHandling: "merge",
                },
              );
            }
          }
        } else {
          if (should_redirect) {
            this.router.navigate(
              [
                `./${
                  this.localStorage.get("data")["user_type"] == 1
                    ? "practice"
                    : "client"
                }/workspaces`,
                _job.client_company,
              ],
              {
                queryParams: {
                  job: _job.uuid,
                },
                fragment: "jobsTab",
                queryParamsHandling: "merge",
              },
            );
          } else {
            this.jobsService.newTemplate.next(_job);
          }
        }

        if (this.bsModalRef != null) {
          this.bsModalRef.hide();
        }
      });
  }

  openRemoveJobModal(template: TemplateRef<any>, job): void {
    this.bsModalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  deleteJob(createInstance: boolean) {
    this.jobsService.deleteJob(this.job, createInstance).subscribe((res) => {
      let _job = <Job>res.new_job;

      if (_job != null) {
        if (_job.client_company == this.job.client_company) {
          this.jobsService.newRecurringJob.next(_job);
        }
      }

      this.jobsStore.removeJob(
        this.job,
        res.deleted_children != null ? false : true,
      );

      this.cdr.detectChanges();

      this.toastr.success(
        !this.templateManager
          ? res.message
          : "Job Template has been successfully deleted",
      );

      //
      if (createInstance) {
        this.jobsStore.reloadJobs$.next(null);
      }

      this.jobNotificationService.notifyJobDeleted(); // Notify the service
      this.dashboardService.closeJobDrawer$.next(true);

      this.bsModalRef.hide();
    });
  }

  selectClient(event) {
    this.duplicateSelectedObj = event.item;
  }

  /*
    This function makes the enter key
    to behave like a tab press when
    the focused element is jobName;
  */
  handleSpecialKeys(attr: string, ev) {
    if (ev.keyCode == 13) {
      ev.preventDefault();

      if (ev.target.id == "jobName") {
        let nextEl = document.getElementById("jobDescription");
        nextEl.focus();
        this.setEndOfContenteditable(nextEl);
      }
    }
  }

  onBlur(selectedElement, task_group = null) {
    if (selectedElement.type == "task") {
      this.saveOrCreateTask(task_group, selectedElement);
    } else {
      this.saveOrCreateTaskGroup(selectedElement);
    }
  }

  launchTrackedItemsModal(taskGroup: TaskGroup) {
    const client_company = this.job.client_company;
    let company_id = null;

    if (client_company != null) {
      company_id =
        typeof client_company == "number"
          ? client_company
          : client_company["id"];
    }

    this.newClientTaskModalRef = this.modalService.show(
      NewTrackedItemModalComponent,
      {
        class: "modal-lg modal-client-tasks",
        ignoreBackdropClick: true,
        initialState: {
          editTemplateMode: this.templateManager,
          isDraft: true,
          conversation_id: company_id,
          isJobDraft: true,
        },
      },
    );

    this.newClientTaskModalRef.content.serializedTrackedItems.subscribe(
      (trackedItems: any) => {
        const last = taskGroup.tasks.slice(-1)[0];

        if (last && last.name == "" && last.uuid.length < 10) {
          taskGroup.tasks.pop();
        }
        trackedItems.forEach((trackedItem: any) => {
          let name = trackedItem.message.replace(
            /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g,
            " ",
          );

          // if no name is provided, we hardcode "Client task"
          name = name ? name : "Client task";
          const task = new Task({ name, related_tracked_item: trackedItem });

          // call endpoint, create this beauty
          this.jobsService.createTask(taskGroup, task).subscribe((res) => {
            Object.assign(task, <Task>res.task);
            taskGroup.tasks.push(task);
            this.setSelectedElement(task, "task");
            this.cdr.detectChanges();
          });
        });
      },
    );
    return;
  }

  removeEmptyTasks(taskGroup: TaskGroup) {
    taskGroup.tasks.forEach((task: Task, idx: number) => {
      if (task.name == "") taskGroup.tasks.splice(idx, 1);
    });
  }

  publishTrackedItem() {
    const tracked_item = this.selectedElement["related_tracked_item"];
    const client_company = this.job.client_company;
    const company_id =
      typeof client_company == "number" ? client_company : client_company["id"];
    this.jobsService.publishTrackedItem(company_id, tracked_item.id).subscribe(
      (res) => this.handlePublishSuccess(this.selectedElement, res),
      (err) => this.handleError(`Couldn't publish the Client Task.`, err),
    );
  }

  handlePublishSuccess(element: any, res: any) {
    element["related_tracked_item"].is_draft = false;
    element["related_tracked_item"].answer_status = "open";
    this.cdr.detectChanges();
    this.toastr.success("Client Task published successfully.");
  }
  handleError(message: string, err: any) {
    console.log(err);
    this.toastr.error(message);
  }

  addEmptyTask(task_group: TaskGroup) {
    const last = task_group.tasks.slice(-1)[0];
    if (last && last.name == "" && last.uuid.length < 10) {
      this.focusTaskByUUID(last.uuid);
      return;
    }

    let task = new Task();
    task_group.tasks.push(task);

    this.focusTaskByUUID(task.uuid);
    this.setSelectedElement(task, "task");
  }

  focusTaskByUUID(task_uuid) {
    setTimeout(() => {
      this.tasks.forEach((t) => {
        if (t.nativeElement.id == `task-${task_uuid}`) {
          t.nativeElement.focus();
        }
      });
    }, 250);
  }

  async goToTrackedItem(trackedItemUuid) {
    let trackedItem =
      await this.conversationsService.get_tracked_item(trackedItemUuid);

    this.dashboardStore.selectTrackedItem(
      trackedItem,
      this.dashboardStore.currentCompany,
    );
  }

  goToWorkspace() {
    // open in a new tab
    window.open(
      `./#/${
        this.localStorage.get("data")["user_type"] == 1 ? "practice" : "client"
      }/workspaces/${this.job.client_company["id"]}/jobs`,
      "_blank",
    );

    // this.router.navigate([
    //   `./${
    //     this.localStorage.get("data")["user_type"] == 1 ? "practice" : "client"
    //   }/workspaces`,
    //   this.job.client_company["id"],
    //   "jobs",
    // ]);
  }

  checkRepeatIsValid(recurrence_options) {
    if (recurrence_options["type"] == null) return false;

    if (recurrence_options["type"] == 0) {
      return (
        recurrence_options["weekly_weeks"] != null &&
        recurrence_options["weekly_day"] != null
      );
    }

    if (recurrence_options["type"] == 1) {
      return recurrence_options["monthly_day"] != null;
    }

    if (recurrence_options["type"] == 3) {
      return true;
    }

    return false;
  }

  cancelRepeatModal(recurrence_options) {
    if (!this.checkRepeatIsValid(recurrence_options)) {
      this.job.recurring = false;
      this.saveOrCreateByJob(this.job);
    }

    this.closeRepeatModal();
  }

  /** COMMENTS TAB */
  /** COMMENTS TAB */
  /** COMMENTS TAB */

  toggleAccountants() {
    this.showAccountants = !this.showAccountants;
  }
  // /**
  //  * Switch between tabs
  //  * @param tab tabname to display (tasks, comments)
  //  */
  // switchTab(tab: string) {
  //   this.activeTab = tab;

  //   if (tab === "comments") {
  //     // refresh everytime the tab is selected
  //     // this.commentsLoading = true;
  //     this.message = "";
  //     this.comments = [];
  //     this.jobsService
  //       .getJobComments(this.job.uuid)
  //       .subscribe(
  //         (res) => this.handleCommentsResponse(res),
  //         (err) => this.handleError(err.message, err)
  //       )
  //       .add(() => {
  //         // this.commentsLoading = false;
  //         this.scrollToEnd();
  //       });

  //     this.realTimeService.setJobNotificationsListener(this.job.uuid);
  //     this.realTimeService.jobCommentNotifications.subscribe((msg: any) => {
  //       if (msg?.text) this.addComment(msg);

  //       this.cdr.markForCheck();
  //       this.cdr.detectChanges();
  //     });
  //   }
  // }

  getStaffMembers() {
    const client_company = this.job.client_company;

    if (client_company == null || client_company["id"] == null) {
      return;
    }
    const companyId =
      typeof client_company == "number" ? client_company : client_company["id"];
    this.accountantService.getStaffMembers(companyId).subscribe(
      (res: any[]) =>
        (this.accountants = res
          .filter((usr) => usr.id !== this.user.id)
          .map((usr) => ({ ...usr, selected: false }))),
      (err) => this.handleError(err.message, err),
    );
  }

  scrollToEnd() {
    if (this.jobsCommentWrapper != null) {
      this.jobsCommentWrapper.nativeElement.scrollTop =
        this.jobsCommentWrapper.nativeElement.scrollHeight;
    }
  }

  addComment(comment: any) {
    // handles a single comment

    if (this.comments == null) {
      this.comments = [];
    }

    const idx = this.comments.findIndex((c: any) => c.uuid == comment.uuid);
    if (idx > -1) {
      this.comments[idx] = comment;
    } else {
      this.comments.push(comment);
      this.job.message_count++;
    }
    if (comment.sent_by?.id != this.user.id) {
      this.selectUserToNotify(comment.sent_by);
    }
  }

  mockComment(hash: string, text: string) {
    const comment: any = {};
    comment.uuid = hash;
    comment.sent_by = this.user;
    comment.text = text;
    comment.created_date = null;
    return comment;
  }

  setCommentAsSent(uuid: string, comment: any) {
    const idx = this.comments.findIndex((c: any) => c.uuid == uuid);
    this.comments[idx] = comment;
  }
  deleteFailedComment(uuid: string) {
    const idx = this.comments.findIndex((c: any) => c.uuid == uuid);
    if (idx > -1) this.comments.splice(idx, 1);
  }

  handleCommentsResponse(res: any) {
    this.comments = res;
    this.job.message_count = this.comments.length;
    const lastSender =
      res[
        res
          .map((comment: any) => comment.sent_by.id !== this.user.id)
          .lastIndexOf(true)
      ]?.sent_by;
    if (lastSender) this.selectUserToNotify(lastSender);

    this.cdr.markForCheck();
    this.cdr.detectChanges();
    this.scrollToEnd();
  }

  getJobComments() {
    if (this.job.uuid.length < 10) {
      return;
    }
    this.jobsService
      .getJobComments(this.job.uuid)
      .subscribe(
        (res) => this.handleCommentsResponse(res),
        (err) => this.handleError(err.message, err),
      )
      .add(() => this.scrollToEnd());
  }

  comment() {
    if (!this.message?.trim()) return;

    const usersToNotify = this.accountants
      ?.filter((ac: any) => ac.selected === true)
      .map((us: any) => us.id);

    this.cdr.markForCheck();
    const hash = Math.random().toString(36).substring(7);
    this.addComment(this.mockComment(hash, this.message));
    this.jobsService
      .comment(this.job.uuid, this.message, usersToNotify)
      .subscribe(
        (res) => {
          this.setCommentAsSent(hash, res);
          this.cdr.detectChanges();
        },
        (err) => {
          this.deleteFailedComment(hash);
          this.handleError(`Message not sent`, err);
        },
      );
    this.message = "";
    this.showAccountants = false;
  }

  selectUserToNotify(accountant: any) {
    if (!accountant) return;
    const objIdx = this.accountants?.findIndex(
      (obj: any) => obj.id === accountant.id,
    );
    this.accountants[objIdx].selected = true;
  }

  getSelectedAccountantsCount() {
    return this.accountants?.filter((it: any) => it.selected === true).length;
  }

  getNotifiedUsersByComment(comment: any) {
    return comment.recipients?.map((it: any) => it.full_name).join(",\n");
  }

  isFirstGroup(groupId: number): boolean {
    return this.job?.task_groups[0]?.id === groupId;
  }

  /**
   * calculates if the Publish This Client Task button should be displayed
   */
  canShowPublishButton(): boolean {
    if (!this.autopilot) {
      // autopilot not set - always display
      return true;
    }

    const currTask = <Task>this.selectedElement;
    if (this.job?.task_groups[0]?.id !== currTask.task_group) {
      // not in first group - always display
      return true;
    }

    const autopilotTasks = [];
    const firstGroupTasks = this.job?.task_groups[0].tasks;
    for (let t of firstGroupTasks) {
      if (!t.related_tracked_item) {
        break;
      }
      autopilotTasks.push(t.id);
    }
    return !autopilotTasks.includes(currTask.id);
  }

  addTagToJob(tag) {
    this.accountantService
      .addJobTag(this.job.uuid, tag.uuid)
      .then((res: any) => {
        this.job.tags.push(res);
        this.cdr.detectChanges();
      });
  }

  removeTagFromJob(tag) {
    this.accountantService
      .removeJobTag(this.job.uuid, tag.uuid)
      .then((res: any) => {
        this.job.tags = this.job.tags.filter((t) => t.uuid !== tag.uuid);
      });
  }

  async launchAdvancedEdit(tracked_item) {
    const trackedItemCopy = { ...tracked_item };
    this.conversationsService
      .getTrackedItemAttachments(tracked_item.uuid)
      .subscribe((res) => {
        trackedItemCopy.files = res;
      });
    let bsModalRef = this.modalService.show(NewTrackedItemModalComponent, {
      class: "modal-lg modal-client-tasks",
      ignoreBackdropClick: true,
      initialState: {
        editTemplateMode: this.templateManager,
        template_edited_uuid: null,
        editMode: true,
        tracked_items: [trackedItemCopy],
      },
    });

    this.conversationsService.updateTrackedItem$.subscribe((data) => {
      this.selectedElement["related_tracked_item"].created_by = data.created_by;
      this.selectedElement["related_tracked_item"].message = data.message;
      this.selectedElement["related_tracked_item"].type = data.type;
      this.selectedElement["related_tracked_item"].attachments = data.files;
      this.selectedElement["related_tracked_item"].initial_reminder_date =
        data.initial_reminder_date;

      this.selectedElement.name = data.task_name;
      this.selectedElement["related_tracked_item"].clients_to_notify =
        data.clients_to_notify;

      this.cdr.detectChanges();
    });
  }

  checkTimeTracking() {
    this.jobTimeTrackingService
      .checkTimeTracking(this.job["uuid"])
      .subscribe((res: any) => {
        this.isTrackingTime = res.is_tracking;
        this.hasCompletedTracking = res.has_completed_tracking;
        this.totalTimeTracked =
          this.jobTimeTrackingService.timeTrackedFormatter(
            res.total_time_tracked,
          );
        this.cdr.detectChanges();
      });
  }

  openTimeTrackingDetailsModal() {
    this.jobTimeTrackingService
      .timeTrackingDetails(this.job["uuid"])
      .then((data: any) => {
        this.bsModalRef = this.modalService.show(
          TimeTrackingDetailsModalComponent,
          {
            initialState: {
              timeTrackingInfo: data.timeTrackingDetails,
              jobUuid: this.job["uuid"],
            },
            class: "modal-xl",
          },
        );
      });
  }

  async timerPause() {
    this.isTrackingTime = null;
    await this.timerService.timerPause();
    this.isTrackingTime = true;
    this.cdr.detectChanges();
  }

  async timerResume() {
    this.isTrackingTime = null;
    await this.timerService.timerResume();
    this.isTrackingTime = true;
    this.cdr.detectChanges();
  }

  openStopConfirmationModal() {
    this.timerService.openStopConfirmationModal(this.job.name);
  }

  async pinJob() {
    if (this.job.pinned_item == null) {
      const { uuid: companyUuid } = await this.notesService.getCompanyUuid(
        this.job.client_company["id"],
      );

      const data = {
        model_name: PinnedModels.Job,
        model_app_name: PinnedModelsApps.Job,
        object_pk: this.job["id"],
      };

      const { pinned_item, message } = await this.pinnedService.pinItem(
        data,
        companyUuid,
      );

      // For UI update purposes, when pinning a note or a job (same screen)
      this.pinnedService.sendNewPinnedItemToComponent.next({ pinned_item });
      this.cdr.detectChanges();
      this.toastr.success(message);
      this.job.pinned_item = pinned_item;
      return;
    } else {
      this.updatePinStatus();
    }
  }

  updatePinStatus() {
    this.pinnedService
      .updatePin(this.job.client_company["uuid"], this.job.pinned_item["uuid"])
      .then(async (res) => {
        this.job.pinned_item["pinned_status"] = res.pinned_status;

        if (res.pinned_status == null) {
          this.pinnedService.unpinItemSubject.next(
            this.job.pinned_item["uuid"],
          );
        }
      });
  }

  openThread() {
    this.genericDrawerService.changeComponent(EmailContentComponent, {
      thread: this.job.related_thread,
      isFromDrawer: true,
    });
  }

  isSender(comment: any): boolean {
    return comment.sent_by.id === this.user.id;
  }

  isDeleted(comment: any): boolean {
    return comment["is_deleted"] ?? false;
  }

  canEdit(comment: any): boolean {
    return !this.isDeleted(comment) && this.isSender(comment);
  }

  canDelete(comment: any): boolean {
    return !this.isDeleted(comment) && this.isSender(comment);
  }

  canRestore(comment: any): boolean {
    return this.isDeleted(comment) && this.isSender(comment);
  }

  toggleMessageVisibility(comment: any) {
    if (!comment.is_deleted) {
      comment.is_deleted = true;
      this.jobsService.deleteComment(comment.uuid).subscribe({
        next: () => {
          comment.is_deleted = true;
          this.job.message_count--;
        },
        error: (e: any) => this.toastr.error("Failed to delete comment"),
      });
    } else {
      this.jobsService.restoreComment(comment.uuid).subscribe({
        next: (n: any) => {
          comment.text = n.text;
          this.job.message_count++;
          comment.is_deleted = false;
        },
        error: (e: any) => this.toastr.error("Failed to restore comment"),
      });
    }
  }

  editMessage(comment: any) {
    comment.edit_mode = true;
  }

  editMessageConfirm(comment: any) {
    this.jobsService.editComment(comment.uuid, comment.text).subscribe({
      next: () => (comment.edit_mode = false),
      error: (e) => {
        console.error(e);
        this.toastr.error("Failed to edit message");
      },
      complete: () => (comment.edit_mode = false),
    });
  }

  cancelEdit(comment: any) {
    comment.edit_mode = false;
  }
  setDueDateOffset(taskGroup: TaskGroup, daysOffset?: number) {
    // don't update if didn't change
    if (taskGroup.due_date === daysOffset) return;
    taskGroup.due_date = daysOffset;
    this.saveOrCreateTaskGroup(taskGroup);
  }

  openDateOffsetModal(taskGroup: TaskGroup) {
    let initialState = {
      title: "Group Due Date Offset",
      headline: "Group Due Date",
      descriptionPre: "This group is due",
      descriptionPost: "day(s) before Job due date",
      cancelText: "Cancel",
      confirmText: "Set Due Date",
      initialValue: taskGroup.due_date,
    };
    let modal = this.modalService.show(DateOffsetPickerComponent, {
      initialState,
    });

    modal.content.valueSelection.subscribe((selected: number | null) =>
      this.setDueDateOffset(taskGroup, selected),
    );
  }

  setCurrentGroup(event: Event, task_group: TaskGroup) {
    event.stopPropagation();
    this.jobsService.setCurrentTaskGroup(task_group).subscribe({
      next: (_) => {
        this.toastr.success("Current group updated successfully");
        this.job.current_group = task_group.name;
        this.jobsService.jobContentChanged.next(this.job);
        this.cdr.detectChanges();
      },
      error: (_) => this.toastr.error("Failed to update current group"),
    });
  }
}
